module.exports = __webpack_public_path__ + "static/img/psychological_assessment.676422f3.png";